"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

exports.apiClientFactory = apiClientFactory;

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _config = require("config");

var _config2 = _interopRequireDefault(_config);

var _jsBase = require("js-base64");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * This silly underscore is here to avoid a mysterious "ReferenceError: ApiClient is not defined" error.
 * See Issue #14. https://github.com/erikras/react-redux-universal-hot-example/issues/14
 *
 * Remove it at your own risk.
 */
var ApiClient_ = function () {
  function ApiClient_(req) {
    var _this = this;

    (0, _classCallCheck3.default)(this, ApiClient_);

    ["get", "post", "put", "patch", "delete"].forEach(function (method) {
      _this[method] = function (path, options) {
        return new _bluebird2.default(function (resolve, reject) {
          var data = null;
          var config = {
            headers: {
              Accept: "application/json"
            }
          };

          if (options && options.params) {
            config.params = options.params;
          }

          if (options && options.data) {
            data = options.data;
          }

          if (options && options.noCache) {
            config.headers.Expires = "-1";
            config.headers["Cache-Control"] = "no-cache,no-store,must-revalidate,max-age=-1,private";
          }

          if (options && options.additionalHeaders) {
            config.headers = (0, _extends3.default)({}, options.additionalHeaders, config.headers);
          }

          if (_this.authToken) {
            config.headers.Authorization = "Bearer " + _this.authToken;
          } else {
            config.headers.Authorization = "";
          }

          var isExternal = options && options.externalCall;
          if (isExternal) {
            config.headers = _ramda2.default.omit(["Authorization"], config.headers);
            config.headers = _ramda2.default.omit(["Accept"], config.headers);
          }

          if (options && options.noHeaders) {
            config = {};
          }

          var promise = ["get", "delete", "head"].indexOf(method) > -1 ? _axios2.default[method](_this.formatUrl(path), config) : _axios2.default[method](_this.formatUrl(path), data || {}, config);
          promise.then(function (r) {
            return options && options.includeHeaders ? resolve({ data: r.data, headers: r.headers }) : resolve(r.data);
          }).catch(function (e) {
            console.error("CALL FAILED ========= ", path, e);
            reject(e instanceof Error ? e.message : e.data);
          });
        }).cancellable();
      };
    });
  }

  (0, _createClass3.default)(ApiClient_, [{
    key: "setAuthToken",
    value: function setAuthToken(_authToken) {
      this.authToken = _authToken;
    }

    /* This was originally a standalone function outside of this class, but babel kept breaking, and this fixes it  */

  }, {
    key: "formatUrl",
    value: function formatUrl(path) {
      var adjustedPath = void 0;
      if (path.startsWith("news://")) {
        adjustedPath = path.split("news://")[1];
        return _config2.default.blogUrl + "/" + adjustedPath;
      } else if (path.startsWith("sso://")) {
        adjustedPath = "/api/" + path.split("sso://")[1];
        return "" + _config2.default.ssoBaseUrl + adjustedPath;
      } else if (path.startsWith("lamda://")) {
        adjustedPath = "/" + path.split("lamda://")[1];
        return "" + _config2.default.lamdaBaseUrl + adjustedPath;
      } else if (path.startsWith("zen://")) {
        adjustedPath = "/api/" + path.split("zen://")[1];
        return "" + _config2.default.apiZendesk + adjustedPath;
      } else if (path.startsWith("stats://")) {
        adjustedPath = path.split("stats://")[1];
        return _config2.default.statsBaseUrl + "/" + adjustedPath;
      } else if (path.startsWith("opt://")) {
        adjustedPath = path.split("opt://")[1];
        return _config2.default.apiOptimizely + "/" + adjustedPath;
      } else if (path.startsWith("cdn://")) {
        adjustedPath = path.split("cdn://")[1];
        return _config2.default.cdnBaseUrl + "/" + adjustedPath;
      } else if (path.startsWith("opt://")) {
        adjustedPath = path.split("opt://")[1];
        return _config2.default.optimizelyApiUrl + "/" + adjustedPath;
      } else if (path.startsWith("hubspot://")) {
        adjustedPath = path.split("hubspot://")[1];
        return _config2.default.hubspotApiUrl + "/" + adjustedPath;
      } else {
        adjustedPath = !path.startsWith("/") ? "/" + path : path;
        return "" + _config2.default.apiBaseUrl + adjustedPath;
      }
    }
  }]);
  return ApiClient_;
}();

var ApiClient = ApiClient_;

function apiClientFactory(req) {
  var _instance = new ApiClient(req);

  return function (authToken) {
    _instance.setAuthToken(authToken);
    return _instance;
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/ApiClient.js
// module id = 2345
// module chunks = 0